/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isalert1Inputs */

const en__field_isalert1 = /** @type {(inputs: _Field_Isalert1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tagged`)
};

const de__field_isalert1 = /** @type {(inputs: _Field_Isalert1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markiert`)
};

/**
* | output |
* | --- |
* | "tagged" |
*
* @param {_Field_Isalert1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_isalert1 = /** @type {((inputs?: _Field_Isalert1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isalert1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_isalert1(inputs)
	return de__field_isalert1(inputs)
});
export { _field_isalert1 as "_field_isAlert" }